import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { NativeBackButton, NativeDeepLinks } from './components/native/NativeShell';
import { initNativeShell } from './components/native/initNativeShell';
import { AuthProvider } from './contexts/AuthContext';
import { TenantProvider } from './contexts/TenantContext';
import './index.css';

function applyAndroidNavInset() {
  const win = window as Window & { Capacitor?: { getPlatform?: () => string } };
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone);
  const isCapacitorAndroid = win.Capacitor?.getPlatform?.() === 'android';
  const isAndroidWebView =
    /Android/i.test(navigator.userAgent) && (isCapacitorAndroid || standalone);
  if (!isAndroidWebView) return;

  const probe = document.createElement('div');
  probe.style.paddingBottom = 'env(safe-area-inset-bottom, 0px)';
  probe.style.position = 'absolute';
  probe.style.visibility = 'hidden';
  document.body.appendChild(probe);
  const reported = parseFloat(getComputedStyle(probe).paddingBottom) || 0;
  probe.remove();

  // Edge-to-edge Android often reports 0; keep tabs above the 48dp system nav.
  document.documentElement.style.setProperty(
    '--app-android-nav',
    reported < 16 ? '48px' : '0px'
  );
}

applyAndroidNavInset();
void initNativeShell();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <NativeBackButton />
      <NativeDeepLinks />
      <AuthProvider>
        <TenantProvider>
          <App />
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);